import { defineStore } from "pinia";

import { AuthenticationManager } from "@core/managers/authentication.manager";
import { FeatureTogglesService } from "@core/services/featureToggles.service";
import { API_NAMESPACE_CANDIDATE } from "@core/constants/api.constants";
import {
  CORE_ACTION_FEATURE_TOGGLES_FETCH_PRIVATE,
  CORE_ACTION_FEATURE_TOGGLES_FETCH_PUBLIC,
  CORE_GETTER_FEATURE_TOGGLES_GET,
  CORE_GETTER_FEATURE_TOGGLES_HAS_FEATURE,
} from "@core/store/types";
import { Logger } from "@core/helpers/logger.helpers";

export const useFeatureTogglesStore = defineStore("featureToggles", {
  state: () => ({
    toggles: {},
  }),
  actions: {
    async [CORE_ACTION_FEATURE_TOGGLES_FETCH_PUBLIC]() {
      try {
        const data = await FeatureTogglesService.getPublic();
        this.toggles = { ...this.toggles, ...data.toggles };
      } catch (error) {
        Logger.error("Cannot retrieve public feature toggles.");
      }
    },
    async [CORE_ACTION_FEATURE_TOGGLES_FETCH_PRIVATE](namespace = API_NAMESPACE_CANDIDATE) {
      try {
        const isUserAuthenticated = await AuthenticationManager.isUserAuthenticated();
        if (!isUserAuthenticated) {
          return;
        }
        const privateData = await FeatureTogglesService.getPrivate(namespace);
        this.toggles = { ...this.toggles, ...privateData.toggles };
      } catch (error) {
        Logger.error("Cannot retrieve private feature toggles.");
      }
    },
  },
  getters: {
    [CORE_GETTER_FEATURE_TOGGLES_GET]: (state) => state.toggles,
    [CORE_GETTER_FEATURE_TOGGLES_HAS_FEATURE]: (state) => (feature) => {
      const toggles = state.toggles;

      const keys = Object.keys(toggles);

      if (keys.length === 0 || !keys.includes(feature)) {
        return false;
      }

      return !!toggles[feature];
    },
  },
});
